import { v4 as uuidv4 } from "uuid";
export class PMOTagReportModel {
    constructor() {
        this.tagId = uuidv4();
        this.projects = [];
    }
}
export default class PMOTagReport extends PMOTagReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
